import {Button, H5, Icon} from '@hm/fundamental'
import {mdiPlus} from '@mdi/js'
import {useFieldArray} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {DetailSectionItem} from './DetailSectionItem'

import {DEFAULT_LAYERS, useEditReplacement} from '@refra/modules/refra-static-parts/providers'

export const DetailSections = () => {
  const {methods, setActiveMaterialInstallationIndex} = useEditReplacement()
  const {control} = methods
  const {t} = useTranslation()

  const {
    fields: materialInstallationFields,
    append,
    remove
  } = useFieldArray({
    control,
    name: 'materialInstallations'
  })

  return (
    <div className="flex flex-col gap-4 overflow-visible">
      <div className="flex items-center justify-between">
        <H5>
          {t('staticParts.editReplacement.sections.title', {
            count: materialInstallationFields.length
          })}
        </H5>
        <Button
          variant="secondary"
          size="small"
          onClick={() => {
            append({
              sectionIds: [],
              layers: DEFAULT_LAYERS
            })
            setActiveMaterialInstallationIndex(materialInstallationFields.length)
          }}
          icon={<Icon path={mdiPlus} />}
        >
          {t('staticParts.editReplacement.sections.add')}
        </Button>
      </div>

      {materialInstallationFields.map((materialInstallationField, materialInstallationIndex) => (
        <DetailSectionItem
          key={materialInstallationField.id}
          materialInstallationIndex={materialInstallationIndex}
          control={control}
          onDelete={() => {
            remove(materialInstallationIndex)
            setActiveMaterialInstallationIndex(0)
          }}
        />
      ))}
    </div>
  )
}
